import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditProductTag from './../edit/EditProductTag';
import Dialog from './DialogBase';

class DialogEditProductTag extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
    this.state = {
      title: '',
    }
  }

  componentDidMount () {
    this._isMounted = true;
    const { tag } = this.props;
    if (tag !== null && tag !== undefined) {
      this._isMounted && this.setState({
        title: "Modifier un tag",
      });
    } else {
      this._isMounted && this.setState({
        title: "Nouveau tag",
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render () {
    const { classes, open, onClose, fullScreen, keepMounted, ...others } = this.props;
    return (
      <Dialog
        keepMounted={keepMounted}
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        title={this.state.title}
      >
        <EditProductTag
          fixedCtrl={true}
          {...others}
        />
      </Dialog>
    )
  }
}

const styles = theme => ({});

DialogEditProductTag.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditProductTag);
